import React from 'react';
import { Typography, Collapse, Space, Divider } from 'antd';
import type { CollapseProps } from 'antd';
import type { ErrorInfo } from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import type { ErrorDisplayInfo } from '../../services/core/ApiErrorHandler';

const { Text, Paragraph } = Typography;

const codeBlockStyle: React.CSSProperties = {
  backgroundColor: '#f6f8fa',
  padding: 8,
  borderRadius: 4,
  whiteSpace: 'pre-wrap',
};

const stackTraceStyle: React.CSSProperties = {
  ...codeBlockStyle,
  fontSize: '10px',
  maxHeight: '200px',
  overflow: 'auto',
};

export const ErrorDetailsPanel: React.FC<{
  displayInfo: ErrorDisplayInfo;
  error: Error | null;
  errorInfo: ErrorInfo | null;
  errorId: string;
}> = ({ displayInfo, error, errorInfo, errorId }) => {
  const collapseItems: CollapseProps['items'] = [
    {
      key: 'details',
      label: (
        <Space>
          <ExclamationCircleOutlined />
          <Text strong>Техническая информация</Text>
        </Space>
      ),
      children: (
        <div style={{ padding: '16px 0' }}>
          <Space orientation="vertical" size="middle" style={{ width: '100%' }}>
            <div>
              <Text strong>ID ошибки:</Text>
              <br />
              <Text code copyable>{errorId}</Text>
            </div>

            <div>
              <Text strong>Время возникновения:</Text>
              <br />
              <Text>{new Date(displayInfo.timestamp).toLocaleString('ru-RU')}</Text>
            </div>

            {displayInfo.operationId && (
              <div>
                <Text strong>ID операции:</Text>
                <br />
                <Text code copyable>{displayInfo.operationId}</Text>
              </div>
            )}

            <Divider />

            {displayInfo.details && (
              <div>
                <Text strong>Описание ошибки:</Text>
                <Paragraph code copyable style={{ ...codeBlockStyle, fontSize: '12px' }}>
                  {displayInfo.details}
                </Paragraph>
              </div>
            )}

            {import.meta.env.DEV && error?.stack && (
              <div>
                <Text strong>Stack Trace:</Text>
                <Paragraph code copyable style={stackTraceStyle}>
                  {error.stack}
                </Paragraph>
              </div>
            )}

            {import.meta.env.DEV && errorInfo?.componentStack && (
              <div>
                <Text strong>Component Stack:</Text>
                <Paragraph code copyable style={stackTraceStyle}>
                  {errorInfo.componentStack}
                </Paragraph>
              </div>
            )}
          </Space>
        </div>
      ),
    },
  ];

  return (
    <div style={{ textAlign: 'left', marginTop: 24 }}>
      <Collapse ghost items={collapseItems} />
    </div>
  );
};
